import { useCallback, useState } from "react";

import EmployeeSalaryAbsenceDeduct from "../pages/EmployeeSalaryAbsenceDeduct";
import EmployeeSalaryAccumulate from "../pages/EmployeeSalaryAccumulate";
import EmployeeSalaryAllowance from "../pages/EmployeeSalaryAllowance";
import EmployeeSalaryBonus from "../pages/EmployeeSalaryBonus";
import EmployeeSalaryIncomDeduction from "../pages/EmployeeSalaryIncomDeduction";
import EmployeeSalaryLateEarltDeduct from "../pages/EmployeeSalaryLateEarlyDeduct";
import EmployeeSalaryLiabilities from "../pages/EmployeeSalaryLiabilities";
import EmployeeSalaryOvertime from "../pages/EmployeeSalaryOvertime";
import EmployeeSalarySalary from "../pages/EmployeeSalarySalary";
import EmployeeSalarySocialSecurity from "../pages/EmployeeSalarySocialSecurity";
import EmployeeSalaryTax from "../pages/EmployeeSalaryTax";

import { EMPLOYEE_SALARY_PAGE } from "../schemas/employeeSalarySchema";

function useEmployeeSalary() {
  const [selectedMenu, setMenu] = useState(EMPLOYEE_SALARY_PAGE.SALARY);

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case EMPLOYEE_SALARY_PAGE.SALARY:
        return <EmployeeSalarySalary />;
      case EMPLOYEE_SALARY_PAGE.BONUS:
        return <EmployeeSalaryBonus />;
      case EMPLOYEE_SALARY_PAGE.INCOME_DEDUCTION:
        return <EmployeeSalaryIncomDeduction />;
      case EMPLOYEE_SALARY_PAGE.OVERTIME:
        return <EmployeeSalaryOvertime />;
      case EMPLOYEE_SALARY_PAGE.ABSENCE_DEDUCT:
        return <EmployeeSalaryAbsenceDeduct />;
      case EMPLOYEE_SALARY_PAGE.LATE_EARLY_DEDUCT:
        return <EmployeeSalaryLateEarltDeduct />;
      case EMPLOYEE_SALARY_PAGE.ACCUMULATE:
        return <EmployeeSalaryAccumulate />;
      case EMPLOYEE_SALARY_PAGE.LIABILITIES:
        return <EmployeeSalaryLiabilities />;
      case EMPLOYEE_SALARY_PAGE.ALLOWANCE:
        return <EmployeeSalaryAllowance />;
      case EMPLOYEE_SALARY_PAGE.TAX:
        return <EmployeeSalaryTax />;
      case EMPLOYEE_SALARY_PAGE.SOCIAL_SECURITY:
        return <EmployeeSalarySocialSecurity />;
      default:
        return <div />;
    }
  }, [selectedMenu]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  return { getPage, handleMenuChange };
}

export default useEmployeeSalary;
